import React, { memo, Component } from 'react';

export default ({resolution, stepNumber, length, track, stepData, trackColor, width=448, height=25, pattern}) => {
    if (stepData === undefined) {
        let steps = pattern.getAllOnStepAtResolutionAtAnyPosition(stepNumber, resolution);
        if (steps.length === 0) {
            return (
                <div></div>
            );
        }
        stepData = steps[0];
    }
    let middle = height/ 2;
    let style = {
        left: width * stepNumber / length,
        width: stepData.duration * width / length,
        top: middle - stepData.transpose / 2,
    };

    if (stepData.on) {
        style['backgroundColor'] =  trackColor;
        
    }

    let className = stepData.on ? 'on' : 'off';

    return (
        <div className={className} style={style}/>
    );
};

